import React from 'react';

export const useHideIntercom = () => {
  React.useEffect(() => {
    hideIntercom();
    return showIntercom;
  }, []);
};

export function hideIntercom() {
  try {
    window.Intercom('update', { hide_default_launcher: true });
    window.Intercom('hide');
  } catch {
    /* ignore exceptions */
  }
}

export function showIntercom() {
  try {
    window.Intercom('update', { hide_default_launcher: false });
  } catch {
    /* ignore exceptions */
  }
}
